import {
  Row,
  Col,
} from 'react-bootstrap'

const CleanUp = () => (
  <Row className="clean-up">
    <Col lg={{ span: 8, offset: 2 }}>
      <h2>Amenities Room Clean-Up Checklist</h2>

      <p className="text-secondary">(Note: Some items do not apply until room is furnished.)</p>

      <ul className="list-group">
        <li className="list-group-item"><i className="fa fa-check me-2" />Return all tables and chairs to their original places</li>
        <li className="list-group-item"><i className="fa fa-check me-2" />Clean all the counters and sinks in the kitchen</li>
        <li className="list-group-item"><i className="fa fa-check me-2" />Wipe out fridge(s)</li>
        <li className="list-group-item"><i className="fa fa-check me-2" />Clean washrooms (toilet, sink and mirror)</li>
        <li className="list-group-item"><i className="fa fa-check me-2" />Remove all garbage, including washroom garbage</li>
        <li className="list-group-item"><i className="fa fa-check me-2" />Sweep floors</li>
        <li className="list-group-item"><i className="fa fa-check me-2" />Vacuum carpeted area</li>
        <li className="list-group-item"><i className="fa fa-check me-2" />Wipe off tables</li>
        <li className="list-group-item"><i className="fa fa-check me-2" />Vacuum couch if dirty</li>
        <li className="list-group-item"><i className="fa fa-check me-2" />Empty vacuum cleaner</li>
        <li className="list-group-item"><i className="fa fa-check me-2" />Put new garbage bags in garbage cans</li>
        <li className="list-group-item"><i className="fa fa-check me-2" />Wipe down bar stools, pillar and wall spills as well as spills on doors</li>
        <li className="list-group-item"><i className="fa fa-check me-2" />Make sure that all windows and doors are locked</li>
      </ul>

    </Col>
  </Row>
)

export default CleanUp
